<template>
    <div class="form">
        <ValidationObserver ref="form">
            <h2 class="profile__title">Personal Information</h2>
            <div class="row">
                <ValidationProvider
                    class="col-md-6"
                    name="Position"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Company Name</label>
                        <select class="custom-select pl-4" v-model="client.company_id">
                            <option
                                v-for="company in companies"
                                :key="company.id"
                                :value="company.id"
                                :selected="client.company_id"
                            >
                                {{ company.name }}
                            </option>
                        </select>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Position"
                    v-slot="{ errors }"
                    rules="required|min:3|latin"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Position*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="client.position"
                        >
                        <FormError :error="errors[0]" name="Position"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="First Name"
                    v-slot="{ errors }"
                    rules="required|min:3|latin"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">First Name*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="generalInfo.first_name"
                        >
                        <FormError :error="errors[0]" name="First Name"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Last Name"
                    v-slot="{ errors }"
                    rules="required|min:3|latin"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Last Name*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="generalInfo.last_name"
                        >
                        <FormError :error="errors[0]" name="Last Name"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Email"
                    v-slot="{ errors }"
                    rules="required|email"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Email Address*</label>
                        <input
                            type="email"
                            class="form-control pl-4"
                            v-model="generalInfo.email"
                        >
                        <FormError :error="errors[0]" name="Email"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Home Phone"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Home Phone*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-mask="'+1 (###) ###-####'"
                            v-model="client.home_phone"
                        >
                        <FormError :error="errors[0]" name="Home Phone"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Mobile Phone Number"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Mobile Phone Number*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-mask="'+1 (###) ###-####'"
                            v-model="generalInfo.phone"
                        >
                        <FormError :error="errors[0]" name="Mobile Phone Number"/>
                    </div>
                </ValidationProvider>
            </div>

            <h2 class="profile__title">Location Information </h2>
            <div class="row">

                <ValidationProvider
                    class="col-12"
                    name="Address"
                    v-slot="{ errors }"
                    rules="required|min:3"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Address*</label>
                        <input type="text" name="" class="form-control pl-4" v-model="client.address">
                        <FormError :error="errors[0]" name="Address"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="State/Province"
                    v-slot="{ errors }"
                    rules="required|min:3"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">City*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="client.city"
                        >
                        <FormError :error="errors[0]" name="City"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="State"
                    v-slot="{ errors }"
                    rules="required|min:3"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">State*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="client.state"
                        >
                        <FormError :error="errors[0]" name="State"/>
                    </div>
                </ValidationProvider>

            </div>

            <BaseButtons
                v-if="isPermission"
                :on-cancel="reloadPage"
                :on-save="validateForm"
            />

        </ValidationObserver>
    </div>

</template>

<script>
import FormError from "../Common/FormError.vue";
import {mapActions, mapState} from "pinia";
import {useClientStore} from "../../stores/ClientStore";
import BaseButtons from "../Common/BaseButtons.vue";
import ModalHandler from "../../mixins/ModalHandler";
import ClientService from "../../services/ClientService";

export default {
    name: 'ClientInformation',
    components: {BaseButtons, FormError},
    mixins: [ModalHandler],
    props: {
        adminType: String
    },
    computed: {
        ...mapState(useClientStore, {
            client: 'client',
            generalInfo: 'generalClientInfo',
            companies: 'companies',
            clientId: 'clientId'
        }),
        isPermission() {
            return this.adminType !== 'agent'
        },
    },

    methods: {
        async updateClientInformation(form) {
            try {
                await ClientService.updateClientInfo(this.clientId, form);
                this.$showSuccessMessage('Profile was successfully updated');
            } catch (error) {
                this.$showErrorMessage('The profile has not been updated');
            }
        },
        async validateForm() {
            const valid = await this.$refs.form.validate();
            if (!valid) {
                this.$showValidationErrorMessage();
            } else {
                const form = {
                    company_id: this.client.company_id,
                    position: this.client.position,
                    first_name: this.generalInfo.first_name,
                    last_name: this.generalInfo.last_name,
                    email: this.generalInfo.email,
                    phone: this.generalInfo.phone,
                    home_phone: this.client.home_phone,
                    address: this.client.address,
                    city: this.client.city,
                    state: this.client.state,

                }
                await this.updateClientInformation(form);
            }
        }
    }
}

</script>


<style scoped>

</style>
